import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

function ConferenceBallroom() {
  const navigate = useNavigate();

  return (
    <div className="page studentCenterPage">
      <div className="background" />
      <div className="page-header">Student Center / Ballroom</div>

      <div className="text-blocks">
        <div className="std-text">
          Make every meeting, social event, ceremony or fundraiser unforgettable with
          Agilysys Sales &amp; Catering. With convenient event booking, menu selection
          and comprehensive logistics management, attendees will be guaranteed a truly
          memorable experience.
        </div>
        <div className="std-text">
          And increase event revenue with yield management insights for group sales,
          conference and banqueting.
        </div>
      </div>

      <FeaturedSolutions>
        <div className="featured-item" onClick={() => navigate('/solutions/sales')}>
          <img src="/assets/higher-ed/solutions/laptop-catering.png" alt="" />
          <div className="item-head">
            <AgilysysLogo />
            Sales &amp; Catering
          </div>
        </div>
      </FeaturedSolutions>
    </div>
  );
}

export default ConferenceBallroom;
